import { Component, Input, Output, EventEmitter } from "@angular/core"
import { ModalController, AlertController } from "ionic-angular"

import { EventService } from "../../services/event"
import { EventDetailPage } from "../../pages/events/detail"
import { EventExchangePage } from "../../pages/events/exchange"
import { EventReleasePage } from "../../pages/events/release"

@Component({
  selector: "event-card",
  templateUrl: "index.html",
})
export class EventCard {

  @Input() event: any = {}
  @Output() statusChanged = new EventEmitter()

  isConfirming = false
  isAccepting = false
  isRejecting = false
  cardClasses = {}

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController
  ) {}

  showConfirmButton() {

    return (this.event.status == "waiting_confirmation" && this.event.canConfirm)
  }

  onShowDetail() {

    const modal = this.modalCtrl.create(EventDetailPage, { eventId: this.event._id })

    modal.onDidDismiss((data) => {

      if (!data)
        return

      if (data.action == "confirmed") {

        this.onConfirm()

      } else if (data.action == "released") {

        this.showReleasePage()

      } else if (data.action == "exchanged") {

        this.showExchangePage()

      } else if (data.action == "accepted") {

        this.onAccept(data.acceptedEvent)

      } else if (data.action == "rejected") {

        this.onReject()

      } else if (data.action == "canceled") {

        this.event = data.event
      }
    })

    modal.present()
  }

  onConfirm() {

    this.isConfirming = true

    EventService.confirmEvent(this.event)
      .then((event) => {

        this.isConfirming = false

        this.updateAndHideEvent(event)
      })
      .catch((error) => {

        console.log(error)

        this.isConfirming = false

        this.alertCtrl.create({
          message: "Falha ao confirmar evento",
          buttons: ["Ok"]
        }).present()
      })
  }

  onAccept(acceptedEvent: any) {

    this.isAccepting = true

    const onError = (error) => {

      console.log(error)

      this.isAccepting = false

      this.alertCtrl.create({
        message: "Falha ao aceitar evento",
        buttons: ["Ok"]
      }).present()
    }

    if (this.event.status == "released") {

      EventService.acceptEventRelease(this.event)
        .then(() => {

          this.isAccepting = false

          this.updateAndHideEvent()
        })
        .catch(onError)

    } else if (this.event.status == "exchange_requested") {

      EventService.acceptEventExchange({ event: this.event, acceptedEvent })
        .then(() => {

          this.isAccepting = false

          this.updateAndHideEvent()
        })
        .catch(onError)
    }
  }

  onReject() {

    this.isRejecting = true

    EventService.rejectEvent(this.event)
      .then(() => {

        this.isRejecting = false

        this.updateAndHideEvent()
      })
      .catch((error) => {

        console.log(error)

        this.isRejecting = false

        this.alertCtrl.create({
          message: "Falha ao rejeitar evento",
          buttons: ["Ok"]
        }).present()
      })
  }

  showReleasePage() {

    const modal = this.modalCtrl.create(EventReleasePage, { event: this.event })

    modal.onDidDismiss((data) => {

      if (data && data.released)
        this.updateAndHideEvent(data.event)
    })

    modal.present()
  }

  showExchangePage() {

    const modal = this.modalCtrl.create(EventExchangePage, { event: this.event })

    modal.onDidDismiss((data) => {

      if (data && data.exchangeRequested)
        this.updateAndHideEvent(data.event)
    })

    modal.present()
  }

  updateAndHideEvent(event?) {

    if (event)
      this.event = event

    this.cardClasses = {
      animated: true,
      zoomOut: true,
    }

    setTimeout(() => {

      this.event.hide = true
      this.statusChanged.emit(this.event)
    }, 800)
  }

  isReleasedOrExchanged() {

    return (this.event.status == "released" || this.event.status == "exchange_requested")
  }

  isReleasedOrExchangedByLoggedUser() {

    return (EventService.isLoggedUserEvent(this.event) && this.isReleasedOrExchanged())
  }

  isReleasedOrExchangedByOtherUser() {

    return (this.isReleasedOrExchanged() && !EventService.isLoggedUserEvent(this.event))
  }

  showConflictsAlert() {

    if (!this.event.hasConflicts)
      return false

    let showMessage = true

    if (!EventService.isLoggedUserEvent(this.event) && this.event.status == "exchange_requested")
      showMessage = false

    return showMessage
  }
}



// WEBPACK FOOTER //
// ./src/components/event-card/index.ts